import { render, staticRenderFns } from "./GroupManagementHelp.vue?vue&type=template&id=49be8269&scoped=true"
import script from "./GroupManagementHelp.vue?vue&type=script&lang=js"
export * from "./GroupManagementHelp.vue?vue&type=script&lang=js"
import style0 from "./GroupManagementHelp.vue?vue&type=style&index=0&id=49be8269&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49be8269",
  null
  
)

export default component.exports